import { Component, OnInit, Output, EventEmitter, Input, ViewChild } from '@angular/core';
import { AssigneeInfo } from '../../../entity';
import { TaskService } from '../../services/task.service';
import { UserService } from '../../services/user.service';
import { UserHelperComponent } from '../user-helper/user-helper.component';
import { NotifyService } from '@farris/ui-notify';
import { DialogComponent } from '@farris/ui-dialog';
import { I18nService } from '../../services/i18n.service';
import { AssigneeInfoByWorkItemIdParameter } from '../../../entity/complete-response';

@Component({
  selector: 'wf-task-assign',
  templateUrl: '../user-helper/user-helper.component.html',
  styleUrls: ['./task-assign.component.css']
})
export class TaskAssignComponent extends UserHelperComponent implements OnInit {

  // title = '请选择指派用户';

  @Input()
  set assigneeInfo(assigneeInfos: AssigneeInfo[]) {
    if (assigneeInfos && assigneeInfos.length > 0) {
      this.assignees = assigneeInfos;
      this.showModal(true);
      this.execute();
    } else {
      this.showModal(false);
    }
  }

  @Output()
  completed = new EventEmitter<boolean>();

  private allUserData: {
    ID: string,
    Code: string,
    Name: string,
    OrgId: string,
    OrgName: string
  }[];
  private assignees: AssigneeInfo[];
  private assigneesPa: AssigneeInfoByWorkItemIdParameter;
  private allowGlobalAssign: boolean;//是否允许全员指派

  constructor(
    public taskSvc: TaskService,
    protected userSvc: UserService,
    protected notify: NotifyService,
    protected i18nService: I18nService
  ) {
    super(i18nService, userSvc);
    this.paginationOptions.id = 'WF-TaskAss-DataTable-Pagination';
    // this.title = this.i18nService.getValue('static.assignee.title');
  }

  ngOnInit() {
  }

  execute() { 
    this.assigneesPa = {
      workItemId: this.assignees[0].workItemId,
      assigneeIds: [],
      comment: ''
    };
    this.singleSelect = !this.assignees[0].multiSelect;
    this.allowGlobalAssign = this.assignees[0].allowGlobalAssign; 
    if(this.assignees[0].assigneeUsers && this.assignees[0].assigneeUsers.length) {
      this.getAssignedUsers();
    } else {
      if(this.allowGlobalAssign) {
        this.getUserList();
      }
    }
    
  }

  getAssignedUsers() {
    this.allUserData = this.assignees[0].assigneeUsers.map( user => {
      return {
        ID: user.id,
        Name: user.name,
        Code: user.code,
        OrgId: user.orgId,
        OrgName: user.orgNamePath
      };
    });
    this.userListData = this.allUserData;
  }

  handleOk() {
    this.selectedUsers = this.singleSelect ? [this.userTable.selections] : this.userTable.selections;

    if (!this.selectedUsers || this.selectedUsers.length < 1) {
      this.notify.warning(this.i18nService.getValue('static.assignee.noAssignee'));
      return;
    }

    this.assignees.shift();
    this.assigneesPa.assigneeIds = this.selectedUsers.map(user => user.ID);

    // 检查指定是否完成，如果完成提交，否则继续指派任务
    if (this.assignees.length > 0) {
      this.userListData = []; // clear source
      this.execute();
    } else {
      this.taskSvc.assignNextUsersByWorkItemId(this.assigneesPa).subscribe(() => {
        this.showModal(false);
        this.notify.success(this.i18nService.getValue('static.assignee.successAssign'));
        this.completed.emit(true);
      }, error => {
        if(error && error.error && error.error.Message) {
          this.notify.error(error.error.Message);
        }
      });
    }
  }

  search(event) {
    if(!this.assignees[0].assigneeUsers || !this.assignees[0].assigneeUsers.length) {
      super.search(event);
    } else {
      this.searchValue = event.value;
      if(this.searchValue) {
        this.userListData = this.allUserData.filter(user => 
          (user.Name) && user.Name.includes(this.searchValue) ||
          (user.Code) && user.Code.includes(this.searchValue)
        );
      } else {
        this.getAssignedUsers();
      }
    }
  }
  protected showModal(show: boolean): void {
    if (show) {
      this.userDialog.show();
    } else {
      // 临时处理方案
      if (this.userDialog.beforeClose) {
        this.userDialog.close();
      }
    }
  }

  onPageSizeChange(pageSize) {
    this.paginationOptions.itemsPerPage = pageSize;
    if(this.allowGlobalAssign) {
      this.getUserList();
    }
  }

  onPageChange(event) {
    this.paginationOptions.currentPage = event.pageIndex;
    if(this.allowGlobalAssign) {
      this.getUserList();
    }
  }
}
